import { render, staticRenderFns } from "./MockPage.vue?vue&type=template&id=1e01bd1c&scoped=true&"
import script from "./MockPage.vue?vue&type=script&lang=js&"
export * from "./MockPage.vue?vue&type=script&lang=js&"
import style0 from "./MockPage.vue?vue&type=style&index=0&id=1e01bd1c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e01bd1c",
  null
  
)

export default component.exports